module.exports = __webpack_public_path__ + "img/back2.60dcfe7c.jpg";